var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.5 472H61.191c-8.539 0-13.687-4.766-16-7.605-3.988-4.907-5.53-11.29-4.234-17.52 20.77-99.766 108.813-172.617 210.453-174.98 1.688.062 3.383.105 5.09.105 74.988 0 136-61.008 136-136S331.488 0 256.5 0c-74.992 0-136 61.008-136 136 0 44.508 21.492 84.094 54.645 108.918-30.372 9.996-58.875 25.547-83.817 46.062-45.73 37.618-77.527 90.086-89.531 147.743-3.762 18.066.746 36.62 12.363 50.91C25.72 503.848 42.863 512 61.191 512H262.5c11.043 0 20-8.953 20-20s-8.957-20-20-20zm-102-336c0-52.934 43.063-96 96-96 52.934 0 96 43.066 96 96 0 52.176-41.84 94.762-93.73 95.973-.747-.086-1.5-.141-2.27-.141-1.562 0-3.121.023-4.68.05-50.77-2.445-91.32-44.515-91.32-95.882zm352 275.98c0 11.047-8.957 20-20 20h-150c-11.047 0-20-8.953-20-20 0-11.042 8.953-20 20-20h150c11.043 0 20 8.958 20 20zM342.5 312h150c11.043 0 20 8.953 20 20s-8.957 20-20 20h-150c-11.047 0-20-8.953-20-20s8.953-20 20-20zm170 180c0 11.047-8.957 20-20 20h-150c-11.047 0-20-8.953-20-20s8.953-20 20-20h150c11.043 0 20 8.953 20 20zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSidebar);
export default __webpack_public_path__ + "static/media/user-sidebar.b1e2fb6b1af1fda2f65a19a6621bd8c1.svg";
export { ForwardRef as ReactComponent };